export default "__VITE_ASSET__DVuVmNLj__"